import React, { useEffect, useRef, useState } from 'react'
import Api from '../../../../_helpers/Api'
import Skeleton from 'react-loading-skeleton'
import { trans } from '../../../../_providers/Translation'
import NoDataFound from '../../../partials/NoDataFound'
import moment from 'moment'
import Menu from '@mui/material/Menu'
import Question from '../../../modals/messages/Question'

import menuIcon from '../../../../assets/img/icons/table-menu.png'
import checkIcon from '../../../../assets/img/icons/check.png'
import deleteIcon from '../../../../assets/img/icons/delete.svg'

function ParserRequests() {

    const questionRef = useRef(null)
    const deleteRef = useRef(null)

    const [state, setState] = useState({
        loading: true,
        data: [],
    })

    const [menu, setMenu] = useState({
        anchor: null,
        id: null,
    })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        setState(prev => ({ ...prev, loading: true }))

        Api.get('banktransactions/parser-requests')
            .then(res => {
                const data = res.data.data || []
                setState(prev => ({
                    ...prev,
                    loading: false,
                    data,
                }))
            })
            .catch(() => {
                setState(prev => ({ ...prev, loading: false }))
            })
    }

    const handleOpenMenu = (e, id) => {
        setMenu({ anchor: e.currentTarget, id })
    }

    const handleCloseMenu = () => {
        setMenu({ anchor: null, id: null })
    }

    const handleMarkAsReady = () => {
        handleCloseMenu()
        questionRef.current.open(menu.id)
    }

    const handleConfirmMarkAsReady = (id) => {
        Api.post('banktransactions/parser-request/mark-as-ready', { id })
            .then(() => {
                setState(prev => ({
                    ...prev,
                    data: prev.data.map(row =>
                        row.id === id ? { ...row, is_ready: 1, marked_ready_at: new Date().toISOString() } : row
                    ),
                }))
            })
    }

    const handleDelete = () => {
        handleCloseMenu()
        deleteRef.current.open(menu.id)
    }

    const handleConfirmDelete = (id) => {
        Api.delete(`banktransactions/parser-request/${id}`)
            .then(() => {
                setState(prev => ({
                    ...prev,
                    data: prev.data.filter(row => row.id !== id),
                }))
            })
    }

    return (
        <div className="pannel">
            <Question
                ref={questionRef}
                mainMessage={trans('buttons.markAsReady')}
                secondaryMessage={trans('messages.markAsReadyConfirm')}
                callback={handleConfirmMarkAsReady}
            />
            <Question
                ref={deleteRef}
                mainMessage={trans('headings.confirmDelete')}
                callback={handleConfirmDelete}
            />

            {state.loading
                ? <Skeleton height={35} count={10} />
                : state.data.length === 0
                    ? <NoDataFound />
                    : <div className="table-scroller">
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: '50px' }}>ID</th>
                                    <th>{trans('tables.date')}</th>
                                    <th>{trans('tables.partner')}</th>
                                    <th>{trans('tables.employee')}</th>
                                    <th>{trans('tables.file')}</th>
                                    <th>{trans('tables.status')}</th>
                                    <th>{trans('tables.markedReadyAt')}</th>
                                    <th className="options">{trans('tables.options')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.data.map(row => (
                                    <tr key={row.id}>
                                        <td style={{ width: '50px' }}>{row.id}</td>
                                        <td>{moment(row.created_at).format('DD.MM.YYYY HH:mm')}</td>
                                        <td>{row.employee?.partner?.name}</td>
                                        <td>{row.employee?.name + ' ' + row.employee?.lastname}</td>
                                        <td>
                                            <a href={`${process.env.REACT_APP_API_URL}/storage/${row.path?.replace('public/', '')}`} target="_blank" rel="noreferrer">
                                                {row.filename}
                                            </a>
                                        </td>
                                        <td>{row.is_ready ? trans('buttons.ready') : trans('buttons.notReady')}</td>
                                        <td>{row.marked_ready_at ? moment(row.marked_ready_at).format('DD.MM.YYYY HH:mm') : '-'}</td>
                                        <td className="options">
                                            <img src={menuIcon} alt="menu" className="menu" onClick={e => handleOpenMenu(e, row.id)} />
                                            <Menu
                                                anchorEl={menu.anchor}
                                                open={Boolean(menu.anchor) && menu.id === row.id}
                                                onClose={handleCloseMenu}
                                            >
                                                {!row.is_ready && (
                                                    <div className="menu-option" onClick={handleMarkAsReady}>
                                                        <img src={checkIcon} alt="ready" />
                                                        {trans('buttons.markAsReady')}
                                                    </div>
                                                )}
                                                <div className="menu-option" onClick={handleDelete} style={{ color: '#EC5252' }}>
                                                    <img src={deleteIcon} alt="delete" />
                                                    {trans('buttons.delete')}
                                                </div>
                                            </Menu>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
            }
        </div>
    )
}

export default ParserRequests
